import { useState } from 'react';
import technicianService from '../../api/technicianService';
import { useNotifications } from '../../context/NotificationContext';

export default function AvailabilityManager({ available, disabled, onChange }) {
  const notify = useNotifications();
  const [busy, setBusy] = useState(false);

  const toggle = async () => {
    setBusy(true);
    try {
      const updated = await technicianService.setAvailability(!available);
      onChange(updated.availableForWork);
      notify.success(updated.availableForWork ? 'You are now accepting bookings' : 'Bookings paused');
    } catch (e) {
      notify.apiError(e);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="card pad spread">
      <div>
        <strong>Accepting bookings</strong>
        <p className="muted" style={{ fontSize: '.88rem' }}>
          {disabled
            ? 'Available once your account is approved.'
            : available
            ? 'Clients can send you booking requests.'
            : 'You are hidden from new booking requests.'}
        </p>
      </div>
      <button
        className={`btn ${available ? 'danger' : 'accent'}`}
        disabled={busy || disabled}
        onClick={toggle}
      >
        {available ? 'Pause bookings' : 'Start accepting'}
      </button>
    </div>
  );
}
